export default __webpack_public_path__ + "static/media/Amealio_Illustrations-02.cea411fe.png";